(() => {
  if (window.petMealsCartEditorLoaded) return;
  window.petMealsCartEditorLoaded = true;

  const editorSelector = '[data-pm-cart-editor]';
  const groupSelector = '[data-pm-cart-group]';
  const deliveryFees = window.PetMealsDeliveryFees;

  function getCartUrl(suffix = '') {
    const base = window.routes?.cart_url || '/cart';
    return suffix ? `${base}${suffix}` : base;
  }

  function parseKeys(value) {
    return String(value || '')
      .split(',')
      .map((key) => key.trim())
      .filter(Boolean);
  }

  function getSectionsToRender() {
    const sections = [];
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems?.dataset.id) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents',
      });
    }

    if (mainCartFooter?.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents',
      });
    }

    if (document.getElementById('cart-icon-bubble')) {
      sections.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      });
    }

    if (document.getElementById('cart-live-region-text')) {
      sections.push({
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      });
    }

    return sections;
  }

  async function fetchJson(url, body) {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json().catch(() => ({}));

    if (!response.ok || data.errors) {
      throw new Error(data.description || data.message || data.errors || 'Unable to update cart.');
    }

    return data;
  }

  async function fetchCart() {
    const response = await fetch(getCartUrl('.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to read the current cart.');
    return response.json();
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  function renderSections(sectionHtml) {
    if (!sectionHtml) return;

    getSectionsToRender().forEach((section) => {
      const root = document.getElementById(section.id);
      const html = sectionHtml[section.section];
      if (!root || !html) return;

      const target = root.querySelector(section.selector) || root;
      const sourceHtml = getSectionInnerHTML(html, section.selector);
      if (target && sourceHtml) target.innerHTML = sourceHtml;
    });
  }

  function syncEmptyState(itemCount) {
    const isEmpty = itemCount === 0;
    document.querySelector('cart-items')?.classList.toggle('is-empty', isEmpty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', isEmpty);
  }

  function setStatus(editor, message, isError = false) {
    const status = editor?.querySelector('[data-pm-cart-status]');
    if (!status) return;

    status.textContent = message;
    status.hidden = !message;
    editor.classList.toggle('has-error', Boolean(isError && message));
  }

  function setBusy(editor, busy, message = '') {
    if (!editor) return;

    editor.dataset.updating = busy ? 'true' : 'false';
    editor.classList.toggle('is-updating', busy);
    editor.querySelectorAll('button, input, select').forEach((control) => {
      control.disabled = busy;
    });

    const cartItems = document.getElementById('main-cart-items');
    cartItems?.classList.toggle('cart__items--disabled', busy);

    setStatus(editor, message);
  }

  function clearBusyState(editor) {
    const editors = new Set();

    if (editor?.isConnected) editors.add(editor);
    document.querySelectorAll(editorSelector).forEach((currentEditor) => editors.add(currentEditor));

    editors.forEach((currentEditor) => {
      currentEditor.dataset.updating = 'false';
      currentEditor.classList.remove('is-updating');
      currentEditor.querySelectorAll('button, input, select').forEach((control) => {
        control.disabled = false;
      });
    });

    document.querySelectorAll('#main-cart-items, #CartDrawer-CartItems').forEach((cartItems) => {
      cartItems.classList.remove('cart__items--disabled');
    });
  }

  function queueClearBusyState(editor) {
    clearBusyState(editor);
    window.requestAnimationFrame?.(() => clearBusyState(document.querySelector(editorSelector) || editor));
    window.setTimeout(() => clearBusyState(document.querySelector(editorSelector) || editor), 0);
  }

  function isShippingFeeItem(item) {
    return item?.properties?._shipfee === 'true';
  }

  function getMealItems(cart) {
    return (cart?.items || []).filter((item) => !isShippingFeeItem(item));
  }

  function getDeliveryDate(item) {
    return item?.properties?.['Selected Consumption Dates'] || '';
  }

  function getDeliveryPeriod(item) {
    return item?.properties?.['Delivery Period'] || '';
  }

  function getCartDeliveryArea(cart) {
    const deliveryItem =
      getMealItems(cart).find((item) => item.properties?.['Delivery Location']) ||
      (cart?.items || []).find((item) => item.properties?.['Delivery Location']);
    if (!deliveryItem) return null;

    return {
      slug: deliveryItem.properties['Delivery Location'],
      name: deliveryItem.properties['Delivery Location Name'] || deliveryItem.properties['Delivery Location'],
    };
  }

  function getShippingFeeMeta(area) {
    const shippingFee = deliveryFees?.getFeeForArea(area) || {
      variantId: '67918712373554',
      label: 'PHP 99.00',
    };

    return {
      variantId: shippingFee.variantId,
      feeLabel: shippingFee.label,
    };
  }

  function copyMealItem(item, area, feeLabel) {
    const properties = { ...(item.properties || {}) };

    if (area) {
      properties['Delivery Location'] = area.slug;
      properties['Delivery Location Name'] = area.name;
    }

    if (feeLabel) {
      properties['Shipping Fee'] = feeLabel;
    }

    const copiedItem = {
      id: item.variant_id,
      quantity: item.quantity,
      properties,
    };

    const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
    if (sellingPlanId) copiedItem.selling_plan = sellingPlanId;

    return copiedItem;
  }

  function buildSharedShippingCartItems(cart, area, excludedMealKeys = []) {
    const excludedKeys = new Set(excludedMealKeys);
    const mealItems = getMealItems(cart).filter((item) => !excludedKeys.has(item.key));
    const { variantId, feeLabel } = getShippingFeeMeta(area);
    const firstShippingByDate = new Map();
    const sharedDates = new Map();
    const items = [];

    (cart.items || []).forEach((item) => {
      if (!isShippingFeeItem(item)) return;
      const date = item.properties?.['Delivery Date'];
      if (date && !firstShippingByDate.has(date)) firstShippingByDate.set(date, item);
    });

    mealItems.forEach((item) => {
      const date = getDeliveryDate(item);

      items.push(copyMealItem(item, area, feeLabel));

      if (!date) return;

      const existingShipping = firstShippingByDate.get(date);
      const dateInfo = sharedDates.get(date) || {
        date,
        deliveryPeriod: existingShipping?.properties?.['Delivery Period'] || getDeliveryPeriod(item),
        variantId,
        feeLabel,
        products: new Set(),
      };

      dateInfo.products.add(item.product_title || item.title);
      sharedDates.set(date, dateInfo);
    });

    sharedDates.forEach((info) => {
      if (!info.variantId) return;

      items.push({
        id: info.variantId,
        quantity: 1,
        properties: {
          _shipfee: 'true',
          'Delivery Date': info.date,
          'Delivery Period': info.deliveryPeriod,
          'Delivery Location': area?.slug || '',
          'Delivery Location Name': area?.name || '',
          'Delivery Fee': info.feeLabel,
          'Linked Products': Array.from(info.products).filter(Boolean).join(', ') || 'Pet Meals',
        },
      });
    });

    return items;
  }

  function cartNeedsSharedShippingRebuild(cart, area) {
    const mealItems = getMealItems(cart);
    const shippingItems = (cart?.items || []).filter(isShippingFeeItem);
    const mealDates = new Set(mealItems.map(getDeliveryDate).filter(Boolean));
    const shippingDates = new Set();
    const targetLocation = area?.slug || '';
    const targetFee = getShippingFeeMeta(area);
    let needsRebuild = false;

    if (mealItems.length === 0) return shippingItems.length > 0;

    mealItems.forEach((item) => {
      const itemLocation = item.properties?.['Delivery Location'] || '';
      const itemShippingFee = item.properties?.['Shipping Fee'] || '';
      if (targetLocation && itemLocation && itemLocation !== targetLocation) needsRebuild = true;
      if (getDeliveryDate(item) && itemShippingFee !== targetFee.feeLabel) needsRebuild = true;
    });

    shippingItems.forEach((item) => {
      const date = item.properties?.['Delivery Date'] || '';
      const location = item.properties?.['Delivery Location'] || '';
      const fee = item.properties?.['Delivery Fee'] || item.properties?.['Shipping Fee'] || '';

      if (Number(item.quantity) !== 1) needsRebuild = true;
      if (String(item.variant_id || '') !== String(targetFee.variantId)) needsRebuild = true;
      if (!date || !mealDates.has(date)) needsRebuild = true;
      if (targetLocation && location && location !== targetLocation) needsRebuild = true;
      if (fee !== targetFee.feeLabel) needsRebuild = true;
      if (date && shippingDates.has(date)) needsRebuild = true;

      if (date) shippingDates.add(date);
    });

    mealDates.forEach((date) => {
      if (!shippingDates.has(date)) needsRebuild = true;
    });

    return needsRebuild;
  }

  async function refreshCartSections() {
    const sections = getSectionsToRender();
    const url = new URL(window.location.href);
    url.searchParams.set('sections', sections.map((section) => section.section).join(','));

    const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
    const sectionHtml = await response.json();
    renderSections(sectionHtml);
  }

  async function updateCartLines(editor, updates, message) {
    const sections = getSectionsToRender();
    const parsedState = await fetchJson(window.routes?.cart_update_url || '/cart/update.js', {
      updates,
      sections: sections.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    renderSections(parsedState.sections);
    syncEmptyState(parsedState.item_count);

    const refreshedEditor = document.querySelector(editorSelector);
    setStatus(refreshedEditor, message);
    queueClearBusyState(refreshedEditor);
  }

  async function rebuildCartWithSharedShipping(cart, area, excludedMealKeys = [], message = 'Cart updated.') {
    const targetArea = area || getCartDeliveryArea(cart);
    const items = buildSharedShippingCartItems(cart, targetArea, excludedMealKeys);

    await fetchJson('/cart/clear.js', {});
    if (items.length) {
      await fetchJson(window.routes?.cart_add_url || '/cart/add.js', { items });
    }

    const updatedCart = await fetchCart();
    await refreshCartSections();
    syncEmptyState(updatedCart.item_count);

    const refreshedEditor = document.querySelector(editorSelector);
    setStatus(refreshedEditor, message);
    queueClearBusyState(refreshedEditor);
  }

  function getQuantityFromInput(input) {
    const quantity = parseInt(input?.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function createUpdates(keys, quantity) {
    return keys.reduce((updates, key) => {
      updates[key] = quantity;
      return updates;
    }, {});
  }

  function setInputQuantity(input, quantity) {
    if (!input) return;
    input.value = String(Math.max(1, quantity));
  }

  async function updateGroupQuantity(editor, group, quantity) {
    const keys = parseKeys(group.dataset.mealKeys);
    if (!keys.length) return;

    await updateCartLines(editor, createUpdates(keys, quantity), 'Cart updated.');
  }

  async function removeGroup(editor, group) {
    const keys = parseKeys(group.dataset.mealKeys);
    if (!keys.length) return;

    const cart = await fetchCart();
    await rebuildCartWithSharedShipping(cart, null, keys, 'Meal plan removed.');
  }

  async function clearCart(editor) {
    const keys = parseKeys(editor.dataset.allCartKeys);
    if (!keys.length) return;

    await updateCartLines(editor, createUpdates(keys, 0), 'Cart cleared.');
  }

  async function rebuildCartArea(editor, select) {
    const selectedOption = select.options[select.selectedIndex];
    const area = {
      slug: select.value,
      name: selectedOption?.dataset.areaName || selectedOption?.textContent?.trim() || select.value,
    };

    if (!area.slug) return;

    const cart = await fetchCart();
    await rebuildCartWithSharedShipping(cart, area, [], `Delivery area updated to ${area.name}.`);
  }

  async function checkSharedShipping(editor) {
    if (!editor || editor.dataset.sharedShippingChecked === 'true') return;
    editor.dataset.sharedShippingChecked = 'true';

    try {
      const cart = await fetchCart();
      const area = getCartDeliveryArea(cart);
      if (!cartNeedsSharedShippingRebuild(cart, area)) return;

      setBusy(editor, true, 'Syncing shared delivery fees...');
      await rebuildCartWithSharedShipping(cart, area, [], 'Shared delivery fees synced.');
    } catch (error) {
      const currentEditor = document.querySelector(editorSelector) || editor;
      queueClearBusyState(currentEditor);
      setStatus(currentEditor, error.message || 'Unable to sync delivery fees.', true);
    }
  }

  async function runEditorAction(editor, message, action) {
    if (!editor || editor.dataset.updating === 'true') return;

    setBusy(editor, true, message);

    try {
      await action();
    } catch (error) {
      const currentEditor = document.querySelector(editorSelector) || editor;
      setStatus(currentEditor, error.message || 'Unable to update cart.', true);
    } finally {
      queueClearBusyState(document.querySelector(editorSelector) || editor);
    }
  }

  document.addEventListener('click', (event) => {
    const editor = event.target.closest(editorSelector);
    if (!editor) return;

    const group = event.target.closest(groupSelector);

    if (event.target.closest('[data-pm-qty-decrease]')) {
      event.preventDefault();
      const input = group?.querySelector('[data-pm-group-quantity]');
      const nextQuantity = Math.max(1, getQuantityFromInput(input) - 1);
      setInputQuantity(input, nextQuantity);
      runEditorAction(editor, 'Updating quantity...', () => updateGroupQuantity(editor, group, nextQuantity));
      return;
    }

    if (event.target.closest('[data-pm-qty-increase]')) {
      event.preventDefault();
      const input = group?.querySelector('[data-pm-group-quantity]');
      const nextQuantity = getQuantityFromInput(input) + 1;
      setInputQuantity(input, nextQuantity);
      runEditorAction(editor, 'Updating quantity...', () => updateGroupQuantity(editor, group, nextQuantity));
      return;
    }

    if (event.target.closest('[data-pm-remove-group]')) {
      event.preventDefault();
      runEditorAction(editor, 'Removing meal plan...', () => removeGroup(editor, group));
      return;
    }

    if (event.target.closest('[data-pm-cart-clear]')) {
      event.preventDefault();
      runEditorAction(editor, 'Clearing cart...', () => clearCart(editor));
    }
  });

  document.addEventListener(
    'change',
    (event) => {
      const editor = event.target.closest(editorSelector);
      if (!editor) return;

      event.stopPropagation();

      if (event.target.matches('[data-pm-group-quantity]')) {
        const input = event.target;
        const group = input.closest(groupSelector);
        const nextQuantity = getQuantityFromInput(input);
        setInputQuantity(input, nextQuantity);
        runEditorAction(editor, 'Updating quantity...', () => updateGroupQuantity(editor, group, nextQuantity));
        return;
      }

      if (event.target.matches('[data-pm-cart-area]')) {
        runEditorAction(editor, 'Updating delivery area...', () => rebuildCartArea(editor, event.target));
      }
    },
    true
  );

  function initSharedShipping() {
    document.querySelectorAll(editorSelector).forEach((editor) => {
      checkSharedShipping(editor);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSharedShipping);
  } else {
    initSharedShipping();
  }

  document.addEventListener('shopify:section:load', initSharedShipping);
})();
